// kutchaCatalogueActionTypes.js
export const FETCH_KUTCHA_CATALOGUE_REQUEST = "FETCH_KUTCHA_CATALOGUE_REQUEST";
export const FETCH_KUTCHA_CATALOGUE_SUCCESS = "FETCH_KUTCHA_CATALOGUE_SUCCESS";
export const FETCH_KUTCHA_CATALOGUE_FAILURE = "FETCH_KUTCHA_CATALOGUE_FAILURE";


// actionTypes.js
export const GENERATE_LOT_NO_REQUEST = 'GENERATE_LOT_NO_REQUEST';
export const GENERATE_LOT_NO_SUCCESS = 'GENERATE_LOT_NO_SUCCESS';
export const GENERATE_LOT_NO_FAILURE = 'GENERATE_LOT_NO_FAILURE';


export const UPDATE_KUTCHA_CATALOGUE_REQUEST = 'UPDATE_KUTCHA_CATALOGUE_REQUEST';
export const UPDATE_KUTCHA_CATALOGUE_SUCCESS = 'UPDATE_KUTCHA_CATALOGUE_SUCCESS';
export const UPDATE_KUTCHA_CATALOGUE_FAILURE = 'UPDATE_KUTCHA_CATALOGUE_FAILURE';
